"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uuids = Uuids;
function Uuids(items) {
    return items.map((item) => {
        return item.uuid;
    });
}
